<template>
  <div class="printerPage">
    <div class="tem">
      <div class="printerBox" @click.prevent="showPrinterPop">
        <div class="titleBox">常用模板</div>
        <div class="codeBox"></div>
        <div class="textBox">
          <span> 型号： </span>
          <span> TCL-01 </span>
        </div>
        <div class="textBox">
          <span> 客户： </span>
          <span> name </span>
        </div>
        <div class="textBox">
          <span> 数量： </span>
          <span> 2000 </span>
        </div>
      </div>

      <div class="reprinterBox">
        <div class="reprint">
          <div></div>
          <el-button size="small" type="danger" class="title" @click="reprint"
            >重新打印</el-button
          >
        </div>
      </div>
    </div>

    <div id="PrintElementOptionSetting"></div>
    <add-record v-if="showPop" @close="close" @save="preView"></add-record>
    <re-print v-if="printerPop" @close="closeRePrint" @save="review"></re-print>
  </div>
</template>
<script>
import "@/assets/plugins/hiprint/css/hiprint.css";
import "@/assets/plugins/hiprint/css/print-lock.css";

import "@/assets/plugins/hiprint/polyfill.min.js";
import "@/assets/plugins/hiprint/plugins/minicolors.min.js";
import { hiprint } from "@/assets/plugins/hiprint/hiprint.bundle.js";
import "@/assets/plugins/hiprint/plugins/jquery.hiwprint.js";
import "@/assets/plugins/hiprint/plugins/qrcode.js";
import "@/assets/plugins/hiprint/plugins/JsBarcode.all.min.js";
import { defaultElementTypeProvider } from "@/assets/plugins/hiprint/etypes/default-etype-provider.js";
import { printData } from "@/assets/plugins/hiprint/custom_test/print-data.js";
import { customPrintJson } from "@/assets/plugins/hiprint/custom_test/custom-print-json.js";
import addRecord from "./pop/addRecord.vue";
import { getBarCode } from "../../api/process";
import { Message } from "element-ui";
import rePrint from "./pop/reprint.vue";
var hiprintTemplate;

export default {
  name: "printer",
  components: { addRecord, rePrint },
  data() {
    return {
      showPop: false,
      printerPop: false,
      printData: "",
      printJson: {
        panels: [
          {
            index: 0,
            height: 40,
            width: 50,
            // paperHeader: 43.5,
            // paperFooter: 85.03937007874016,
            paperNumberDisabled: true,
            // paperNumberFormat:'paperNo-paperCount' ,
            printElements: [
              {
                options: {
                  left: 9,
                  top: 12,
                  height: 20,
                  width: 130,
                  title: "",
                  textType: "barcode",
                  fontSize: 12.5,
                },
                printElementType: { type: "text" },
              },
              {
                options: {
                  left: 9,
                  top: 50,
                  height: 9.75,
                  width: 120,
                  title: "型号：",
                },
                printElementType: { type: "text" },
              },
              {
                options: {
                  left: 41.5,
                  top: 50,
                  height: 9.75,
                  width: 120,
                  title: "TCL-02",
                },
                printElementType: { type: "text" },
              },
              {
                options: {
                  left: 9,
                  top: 70,
                  height: 9.75,
                  width: 120,
                  title: "客户：",
                },
                printElementType: { type: "text" },
              },
              {
                options: {
                  left: 41.5,
                  top: 70,
                  height: 9.75,
                  width: 120,
                  title: "name",
                },
                printElementType: { type: "text" },
              },
              {
                options: {
                  left: 10.5,
                  top: 90,
                  height: 9.75,
                  width: 120,
                  title: "数量：",
                },
                printElementType: { type: "text" },
              },
              {
                options: {
                  left: 41.5,
                  top: 90,
                  height: 9.75,
                  width: 120,
                  title: "1000",
                },
                printElementType: { type: "text" },
              }
            ],
            paperNumberLeft: 120,
            paperNumberTop: 63,
          },
        ],
      },
    };
  },
  methods: {
    reprint() {
      this.printerPop = true;
    },
    showPrinterPop() {
      this.showPop = true;
    },
    closeRePrint() {
      this.printerPop = false;
    },
    review(data) {
      let that = this;
      // this.printData = data;
      this.printJson["panels"][0]["printElements"][0]["options"]["title"] =
        data["barcode"];
      this.printJson["panels"][0]["printElements"][2]["options"]["title"] =
        data["model_type"];
      this.printJson["panels"][0]["printElements"][4]["options"]["title"] =
        data["customer"];
      this.printJson["panels"][0]["printElements"][6]["options"]["title"] =
        data["quantity"];
      hiprintTemplate = new hiprint.PrintTemplate({
        template: that.printJson,
        settingContainer: "#PrintElementOptionSetting",
        paginationContainer: ".hiprint-printPagination",
      });
      hiprintTemplate.print(printData);
    },
    preView(data) {
      let that = this;
      // this.printData = data;
      this.printJson["panels"][0]["printElements"][2]["options"]["title"] =
        data["model_type"];
      this.printJson["panels"][0]["printElements"][4]["options"]["title"] =
        data["customer"];
      this.printJson["panels"][0]["printElements"][6]["options"]["title"] =
        data["quantity"];
      console.log(hiprintTemplate);

      getBarCode(data)
        .then((res) => {
          that.printJson["panels"][0]["printElements"][0]["options"]["title"] =
            res["datelist"]["bar_code"].toString();
          hiprintTemplate = new hiprint.PrintTemplate({
            template: that.printJson,
            settingContainer: "#PrintElementOptionSetting",
            paginationContainer: ".hiprint-printPagination",
          });
          hiprintTemplate.print(printData);
        })
        .catch((e) => {
          // Message.error(e);
          console.log(e);
        });
    },
    close() {
      this.showPop = false;
    },

    save() {},
  },
  mounted() {
    let self = this;
    $(document).ready(function () {
      //初始化打印插件
      hiprint.init({
        providers: [new defaultElementTypeProvider()],
      });

      //设置左侧拖拽事件
      // hiprint.PrintElementTypeManager.buildByHtml($(".ep-draggable-item"));
      let _customPrintJson = customPrintJson;
      hiprintTemplate = new hiprint.PrintTemplate({
        template: _customPrintJson,
        settingContainer: "#PrintElementOptionSetting",
        paginationContainer: ".hiprint-printPagination",
      });
      //打印设计
      // hiprintTemplate.design("#hiprint-printTemplate");
      // self.setCurrentPaper(self.paperMap.A4);
      // self.elementAddEventListen();
      // $(".params_drawer").width($(".params_setting_container").width() * 1); //动态设置右部参数设置框宽度
    });
  },
};
</script>

<style lang="less">
.printerPage {
  width: 100%;
  height: 100%;

  .tem {
    display: flex;
    justify-content: space-between;
    .reprinterBox {
      width: 100px;
      height: 100px;
      border-radius: 32px;

      .reprint {
        text-align: center;
      }
    }
    .printerBox {
      width: 300px;
      height: 200px;
      border-radius: 32px;
      border: 1px solid palegoldenrod;
      .titleBox {
        text-align: center;
        font-size: 30px;
      }
      .codeBox {
        width: 100%;
        height: 100px;
        background: url("../../assets/img/barcode.png");
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
      .textBox {
        padding-left: 30px;
        text-align: left;
        font-size: 20px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/printerManage/index.vue